export enum SubscriptionPlanType {
  TRIAL = 'mm-online-trial',
  PRO = 'mm-online-pro',
  ENTERPRISE = 'mm-online-enterprise',
  OPEN_GUEST = 'mm-online-openguest',
  ENTERPRISE_USER = 'enterprise-user'
}
